import moment from 'moment'
import 'moment-timezone'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import { api_gateway } from '../../conexoes/api.js'
import {
  atualizarMensagemCabecalhoSelecionada,
  atualizarMensagensCabecalho,
  atualizarMensagensCabecalho as atualizarMensagensCabecalhoFunc,
  revelarMensagemCabecalhoSelecionada
} from '../../redux/actions/index'
import {
  elipseVerde,
  fecharJanela,
  logoRedondo
} from '../../utils/alternanciaIcones'
import '../../css/painelMensagens/painelMensagens.css'

export default function Mensagem(props) {
  const [titulo, setTitulo] = useState('')
  const [corpoMensagem, setCorpoMensagem] = useState('')
  const [dataHora, setDataHora] = useState('')
  const despacho = useDispatch()
  const modal = useRef()
  let mensagemCabecalhoSelecionada = useSelector(
    (state) => state.mensagensState.mensagemCabecalhoSelecionada
  )
  let revelarMensagemTabela = useSelector(
    (state) => state.mensagensState.revelarMensagemTabela
  )
  const manejador = useSelector((state) => state.manejadorState.manejador)

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  useEffect(() => {
    if (mensagemCabecalhoSelecionada) {
      setTitulo(mensagemCabecalhoSelecionada.ds_titulo)

      setCorpoMensagem(
        '<span class="fonte-texto-mensagem fonte-cor-1" >' +
          mensagemCabecalhoSelecionada.tx_texto +
          ' </span>'
      )
      setDataHora(
        moment(mensagemCabecalhoSelecionada.dt_created_at).format(
          'DD/MM/YYYY - H:mm'
        )
      )
    }

    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function handleCancelar() {
    despacho(revelarMensagemCabecalhoSelecionada(false))
    despacho(atualizarMensagemCabecalhoSelecionada(undefined))
    if (!revelarMensagemTabela) {
      props.handleRevelarMensagens(true)

      if (
        manejador === 'telaInicial' &&
        mensagemCabecalhoSelecionada.fl_lido == 0
      ) {
        // nova mensagem ao logar
        const cd_msg_mensagem_plataforma =
          mensagemCabecalhoSelecionada.cd_msg_mensagem
        const bodyAlteracao = {
          condicao: {
            cd_msg_mensagem_plataforma
          },
          dados: {
            fl_lido: 1
          }
        }
        await api_gateway.post('/m1/alterar/mensagem', bodyAlteracao)
        despacho(atualizarMensagensCabecalhoFunc(!atualizarMensagensCabecalho))
      }
    }
  }

  return (
    <Form ref={modal}>
      <div className="modal-mensagem fundo-cor-6">
        <Form.Row>
          <Col>
            <Button
              className="botao-fechar-janela"
              variant="danger"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </Button>
          </Col>
        </Form.Row>
        <Form.Row>
          <div className="grupo-mensagem-1">
            <div className="coluna-mensagem-1">
              <div className="container-logo-titulo-mensagem">
                <img
                  className="icone-logo-redondo-mensagem"
                  src={logoRedondo()}
                  alt="logo redondo"
                />
                <div className="titulo-mensagem">
                  <span className="fonte-titulo-mensagem fonte-cor-1">
                    {titulo}
                  </span>
                </div>
              </div>
            </div>
            <div className="coluna-mensagem-2">
              <div className="data-hora-mensagem">
                <span className="fonte-data-hora-mensagem fonte-cor-1">
                  {dataHora}
                </span>
                <img
                  className="icone-elipse-mensagem"
                  src={elipseVerde()}
                  alt="elipse"
                />
              </div>
            </div>
          </div>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="container-mensagem">
              <div
                className="texto-mensagem"
                dangerouslySetInnerHTML={{ __html: corpoMensagem }}
              />
            </div>
          </Col>
        </Form.Row>
      </div>
    </Form>
  )
}
